
(function() {
    function C24InputMask(el, opts) {
        window.IMask.InputMask.call(this, el, opts);
    }

    C24InputMask.prototype = Object.create(window.IMask.InputMask.prototype);
    C24InputMask.prototype.constructor = C24InputMask;

    C24InputMask.prototype._onInputOriginal = C24InputMask.prototype._onInput;

    C24InputMask.prototype._onInput = function(e) {

        if (this.el.value.length < this.value.length
            && this._selection.start === this._selection.end) {

            const findFirstDiffPos = function(a, b)
            {
                const shorterLength = Math.min(a.length, b.length);

                for (let i = 0; i < shorterLength; i++)
                {
                    if (a[i] !== b[i]) return i;
                }

                if (a.length !== b.length) return shorterLength;

                return -1;
            };

            const diffPos = findFirstDiffPos(this.el.value, this.value);

            if (diffPos !== -1 && diffPos > 1 && this.value.charAt(diffPos) === '.') {

                this.el.value = this.el.value.substring(0, diffPos - 1) + '.' + this.el.value.substring(diffPos);

                this._selection = {
                    start: diffPos,
                    end: diffPos,
                };

                this.el.select(diffPos, diffPos);
            }
        }

        this._onInputOriginal(e);

        if (this.adjustCursorPos) {
            this.updateCursor(this.cursorPos + this.adjustCursorPos);
            this.adjustCursorPos = 0;
        }
    };

    window.C24InputMask = C24InputMask;
})();
